// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app" + "." + "9a3a0feaae64a87ac697" + ".css";
};